import axios from "axios";
export const USERS_URL = process.env.REACT_APP_API_URL;

export const getAllSubcenter = async (centerId) => {
  return await axios.post(
    `${USERS_URL}/settings/read-all-subcenters-master-data`,
    { centerId: centerId }
  );
};

export const getAllCountry = async () => {
  return await axios.get(
    `${USERS_URL}/settings/read-all-countries-master-data`
  );
};

export const getAllBanks = async () => {
  return await axios.get(`${USERS_URL}/settings/read-all-banks`);
};

export const getAllDepartments = async () => {
  return await axios.get(`${USERS_URL}/settings/read-all-dept`);
};

export const getCityByCountryId = async (countryId) => {
  return await axios.post(`${USERS_URL}/settings/read-all-cities-master-data`, {
    countryId: countryId,
  });
};

export const getVehiclesByCenterAndSubcenterId = async (body) => {
  return await axios.post(
    `${USERS_URL}/settings/read-all-vehicles-by-centerId-master-data`,
    body
  );
};

export const getDashboardVehicle = async (body) => {
  // console.log("Dashboard Request body", body);
  return await axios.post(
    `${USERS_URL}/settings/read-all-vehicles-dashboard`,
    body
  );
};

export const updateVehicleStatus = async (body) => {
  return await axios.put(`${USERS_URL}/vehicles/update-vehicle-status`, body);
};

export const getLastTrips = async (body) => {
  // console.log("Call in crud", body);
  return await axios.post(
    `${USERS_URL}/drivertriplog/read-all-driver-trip-logs-by-vehicleId`,
    body
  );
};

export const updateTripLog = async (payload) => {
  // console.log("payload in crud", payload);
  return await axios.put(
    `${USERS_URL}/drivertriplog/update-driver-trip-log`,
    payload
  );
};

export const getAlaramTime = async () => {
  return await axios.get(
    `${USERS_URL}/settings/read-all-alarmtimes-master-data`
  );
};

export function getEmployeeHierarchy(level) {
  return axios.get(`${USERS_URL}/settings/employee_hierarchy/${level}`);
}

export const getEmployeeProfile = async () => {
  return await axios.get(`${USERS_URL}/profile/read-profile`);
};

export async function getAllLeaveBalances(body) {
  return axios.post(
    `${USERS_URL}/leave_request/read-all-employee-leave-balance`,
    body
  );
}

export async function getProfileInfo(body) {
  return axios.post(`${USERS_URL}/emp_portal/read-profile-by-empId`, body);
}

export async function getContactInfo(body) {
  return axios.post(`${USERS_URL}/emp_portal/read-contact-by-empId`, body);
}

export async function getExperienceInfo(body) {
  return axios.post(`${USERS_URL}/emp_portal/read-experience-by-empId`, body);
}

export async function getAcademicInfo(body) {
  return axios.post(`${USERS_URL}/emp_portal/read-all-academic-by-empId`, body);
}

export async function getSkillsInfo(body) {
  return axios.post(`${USERS_URL}/emp_portal/read-all-skills-by-empId`, body);
}

export async function getReportingEmployee(body) {
  return axios.post(
    `${USERS_URL}/emp_portal/read-reporting-profile-by-empId`,
    body
  );
}

export async function getLoanDetail(body) {
  return axios.post(
    `${USERS_URL}/emp_portal/read-employee-loan-request-by-empId`,
    body
  );
}

export async function getHolidayDetail(body) {
  return axios.post(`${USERS_URL}/emp_portal/read-holidays-by-empId`, body);
}

export function getPayrollMonth(body) {
  return axios.post(
    `${USERS_URL}/payroll_month/get-payroll-month-previous-date`,
    body
  );
}

//// dashbaord related service

export function getDashboardAlert(body) {
  return axios.post(`${USERS_URL}/dashboard/dashboard-alert`,body);
}

export function getSummary(filter) {
  return axios.post(`${USERS_URL}/dashboard/summary`, filter );
}

export function getSummaryDetail(filter) {
  return axios.post(`${USERS_URL}/dashboard/summary-detail`, filter );
}

export function getRecruitmentSummary(filter) {
  return axios.post(`${USERS_URL}/dashboard/recruitment-summary`, filter );
}


export function getAnnouncment(filter) {
  return axios.get(`${USERS_URL}/dashboard/announcement` );
}
export function getExitReason(id) {
 
  return axios.get(`${USERS_URL}/settings/read-all-exit-reason/${id}`);
}

export function updatePortalDashboardType(body) {
  return axios.post(`${USERS_URL}/settings/update-portal-view` , body);
}

export async function getAttendance(body) {
  return axios.post(`${USERS_URL}/emp_portal/read-attendance` , body);
}

export async function getPortalInfo(body) {
  return axios.post(`${USERS_URL}/emp_portal/get-employee-portal-info` , body);
}

export async function getEmpProfileInfo() {
  return axios.get(`${USERS_URL}/emp_portal/get-employee-profile`);
}


export async function getCurrentDateTime(payload) {
  return axios.get(`https://timeapi.io/api/time/current/zone?timeZone=${payload}`);
}

export async function createAttendance(body) {
  return axios.post(`${USERS_URL}/emp_portal/create-attendance` , body);
}
export async function getAllUser(body) {
  return axios.post(`${USERS_URL}/settings/read-all-users` , body);
}
export async function getAllAuditTablesName(body) {
  return axios.post(`${USERS_URL}/settings/read-all-audit-table-names` , body);
}

export const getAllFiscalYearBySubsidiaryId = async (body) => {
  return await axios.post(`${USERS_URL}/settings/read-all-fiscal-year-by-SubsidiaryId`,body);
};

export const getAllAppraisalPeriodBySubsidiaryId = async (body) => {
  return await axios.post(`${USERS_URL}/settings/read-all-appraisal-period-by-SubsidiaryId`,body);
};

export const getAllDepartmentBySubsidiaryIds = async (body) => {
  return await axios.post(`${USERS_URL}/settings/read-all-department-by-SubsidiaryIds`,body);
};
export const getAllAppraisalPeriod = async (body) => {
  return await axios.post(`${USERS_URL}/settings/read-all-appraisal-period`,body);


};export const getAllApprovedResignedEmp = async (body) => {
  return await axios.post(`${USERS_URL}/settings/read-all-approved-resigned-employee`,body);
};

export const getAllGeoLocationBySubsidiary = async (body) => {
  return await axios.post(`${USERS_URL}/settings/read-all-geo-location-by-subsidiary`,body);
};

export const getDeviceIdByEmpId = async (body) => {
  return await axios.post(`${USERS_URL}/settings/read-device-by-empId`,body);
};
export const getAllEarning = async () => {
  return await axios.get(`${USERS_URL}/settings/read-all-earning`);
};

export const getSeparatedEmployeeById = async (id) => {
  return await axios.get(`${USERS_URL}/settings/read-separated-employeeById/${id}`);
};

export const getAllSalaryRoundingByFilters = async (body) => {
  return await axios.get(`${USERS_URL}/settings/read-all-rounding-policy`);
};

export const getProfileDetailInfo = async (id) => {
  return await axios.get(`${USERS_URL}/settings/read-profile-detail-info/${id}`);
};

export const getAllApprovedFSEmp = async (body) => {
  return await axios.post(`${USERS_URL}/settings/read-all-approved-fs-employee/`,body);
};

export const getAllTaxYearSetup = async (subsidiaryId) => {
  return await axios.get(`${USERS_URL}/settings/read-all-tax-year-setup/${subsidiaryId}`);
};
export const getSeparatedAttSummaryEmpById = async (id) => {
  return await axios.get(`${USERS_URL}/settings/read-separated-att-summary/${id}`);
};

export const requestRaisedBySenior = async () => {
  return await axios.get(`${USERS_URL}/settings/request-raised-by-senior`);
};


export function uploadFiles(body) {
  return axios.post(`${USERS_URL}/file-upload`, body);
}

export const getAllFacilitatorEmployee = async (Id) => {
  return await axios.get(`${USERS_URL}/settings/read-all-facilitator-employee/${Id}`);
}
export const getAllFacilitatorTicketType = async () => {
  return await axios.get(`${USERS_URL}/settings/read-all-facilitator-ticket-type`, );
};

export function updateDefaultSubsidiary(body) {
  return axios.post(`${USERS_URL}/settings/update-default-subsidiary`, body);
}

export function getModuleRights() {
  return axios.get(`${USERS_URL}/settings/read-all-modules-right`);
}

export function getUsersByCompanyId(body) {
  return axios.post(`${USERS_URL}/settings/read-all-user-by-companyId` , body);
}

export const getAllActiveCustomers = async () => {
  return await axios.get(`${USERS_URL}/settings/read-all-customers`);
};

export const getAllProjects = async (body) => {
  return await axios.post(`${USERS_URL}/settings/read-all-project`, body);
};

export const getAllTicketStatus = async () => {
  return await axios.get(`${USERS_URL}/settings/read-all-ticket-status`);
};

export const getAllTicket = async (body) => {
  return await axios.post(`${USERS_URL}/settings/read-all-ticket`, body);
};

export const getTicketById = async (body) => {
  return await axios.post(`${USERS_URL}/settings/read-ticket-byId`, body);
};
export const getAllMasterTicketType = async (body) => {
  return await axios.post(`${USERS_URL}/settings/read-master-ticket-type`, body);
};

export const getAllCompanyEmployeesData = async () => {
  return await axios.get(`${USERS_URL}/settings/read-all-profile-by-company`);
};
export const getAllCurrentParentTask = async () => {
  return await axios.get(`${USERS_URL}/settings/read-all-current-parent-ticket`);


};export const getAllAlertTasks = async () => {
  return await axios.get(`${USERS_URL}/portal_ticket_creation/read-alert-facilitator-ticket-creation`);
};

export const getAttLogsByDate = async (body) => {
  return await axios.post(`${USERS_URL}/settings/read-date-att-logs`, body);
};

export const getAllBudgetYearBySubsidiaryId = async (body) => {
  return await axios.post(`${USERS_URL}/settings/read-all-budget-year-by-SubsidiaryId`,body);
};
export const getAllBudgetRequest = async (body) => {
  return await axios.post(`${USERS_URL}/settings/read-all-active-budget-request`,body);
};
export const getAllComDept = async () => {
  return await axios.get(`${USERS_URL}/settings/read-all-comp-dept`,);
};
export const getAllDesignationByDepId = async (body) => {
  return await axios.post(`${USERS_URL}/settings/read-all-designation-by-depId`,body);
};

export const getAllParentSubsidiaries = async () => {
  return await axios.get(`${USERS_URL}/subsidiary/read-all-parent-subsidiaries`);
};
export const getAllAssetModelName = async (params = {}) => {
  return await axios.get(`${USERS_URL}/settings/read-all-model-name`, {
    params,
  });
};

export const getAllRegisterAssetName = async (params = {}) => {
  return await axios.get(`${USERS_URL}/settings/read-all-register-asset`, {
    params,
  });
};

export const getAllPresentUnassignedCategory = async (body) => {
  return await axios.post(`${USERS_URL}/settings/read-all-unassigned-category`,body);
};
export const getAllPresentUnassignedMakeCompany = async (body) => {
  return await axios.post(`${USERS_URL}/settings/read-all-unassigned-make-company`,body);
};

export const getAssetDetailViewSection = async (Id) => {
  return await axios.get(`${USERS_URL}/settings/read-all-asset-detail-view-section/${Id}`);

}
export const getAssetInspectionListById = async (Id) => {
  return await axios.get(`${USERS_URL}/settings/read-all-asset-inspection-list/${Id}`);
}
export const getAssetAssignmentListByEmpId = async (Id) => {
  return await axios.get(`${USERS_URL}/settings/read-all-asset-assignment-list-by-empId/${Id}`);
}
export const getAssetChecklistById = async (Id) => {
  return await axios.get(`${USERS_URL}/settings/read-all-asset-checklist/${Id}`);
}
export const getOvertimeEntitledEmployeesData = async (body) => {
  return await axios.post(`${USERS_URL}/settings/read-all-overtime-entitled-employees`,body);
}

export function getAttendanceTaskLogs(employeeId, loggedDate,toDate) {
  return axios.get(
    `${USERS_URL}/settings/read-all-attendance-timelog-detail`,
    {
      params: {
        employeeId,
        loggedDate,
        toDate,
      },
    }
  );
}
export function getAllTaskDetail(taskId) {
  return axios.get(
    `${USERS_URL}/settings/read-all-task-detail`,
    {
      params: {
        taskId,
      
      },
    }
  );
}

export const getApplicantSelectedStatusForDisabled = async (Id) => {
  return await axios.get(`${USERS_URL}/settings/read-all-applicant-disbaled-status`)};